"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    documentUploads: {
        path: "/files"
    },
    documentUploadDetail: {
        path: "/files/:id"
    },
    documentUploadFile: {
        path: "/view-file/:id"
    },
    geocodeDocument: {
        path: "/geocode-file/:id"
    },
    viewCertificateForReport: {
        path: "/certificates/:id"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvZG9jdW1lbnRVcGxvYWRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgZG9jdW1lbnRVcGxvYWRzOiB7XG4gICAgcGF0aDogXCIvZmlsZXNcIixcbiAgfSxcbiAgZG9jdW1lbnRVcGxvYWREZXRhaWw6IHtcbiAgICBwYXRoOiBcIi9maWxlcy86aWRcIixcbiAgfSxcbiAgZG9jdW1lbnRVcGxvYWRGaWxlOiB7XG4gICAgcGF0aDogXCIvdmlldy1maWxlLzppZFwiLFxuICB9LFxuICBnZW9jb2RlRG9jdW1lbnQ6IHtcbiAgICBwYXRoOiBcIi9nZW9jb2RlLWZpbGUvOmlkXCIsXG4gIH0sXG4gIHZpZXdDZXJ0aWZpY2F0ZUZvclJlcG9ydDoge1xuICAgIHBhdGg6IFwiL2NlcnRpZmljYXRlcy86aWRcIixcbiAgfSxcbn0pO1xuIl0sIm5hbWVzIjpbInJvdXRlcyIsImJ1aWxkUm91dGVzIiwiZG9jdW1lbnRVcGxvYWRzIiwicGF0aCIsImRvY3VtZW50VXBsb2FkRGV0YWlsIiwiZG9jdW1lbnRVcGxvYWRGaWxlIiwiZ2VvY29kZURvY3VtZW50Iiwidmlld0NlcnRpZmljYXRlRm9yUmVwb3J0Il0sIm1hcHBpbmdzIjoiOzs7OytCQUVhQTs7O2VBQUFBOzs7dUJBRmU7QUFFckIsTUFBTUEsU0FBU0MsSUFBQUEsa0JBQVcsRUFBQztJQUNoQ0MsaUJBQWlCO1FBQ2ZDLE1BQU07SUFDUjtJQUNBQyxzQkFBc0I7UUFDcEJELE1BQU07SUFDUjtJQUNBRSxvQkFBb0I7UUFDbEJGLE1BQU07SUFDUjtJQUNBRyxpQkFBaUI7UUFDZkgsTUFBTTtJQUNSO0lBQ0FJLDBCQUEwQjtRQUN4QkosTUFBTTtJQUNSO0FBQ0YifQ==